import { Gender } from 'src/domain';
import { useIsUsingGender } from './useIsUsingGender';

export const useDefaultGender = () => {
    const isUsingGenderSplit = useIsUsingGender();

    return isUsingGenderSplit ? Gender.Male : Gender.Other;
};
